import { AttributeSelectorType, AttributeType, StringSubType } from "@evergis/api";
import { Link } from "@evergis/ui";
import React, { FC, ReactNode, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ResourceTypeItem } from "../../ResourceType/types";

import {
  Hint,
  ImageFormatPreviewContainer,
  ImagePreview,
  ImagePreviewIcon,
  Label,
  StringFormSettingsContainer,
  StringFormSettingsContentContainer,
  StringResourceType,
} from "./styled";

type StringFormatSettingsProps = {
  type: AttributeType;
  subType?: StringSubType;
  attributeSelectorType?: AttributeSelectorType;
  childrenBefore?: ReactNode;
  onChangeFormatSubType?: (value: StringSubType) => void;
};

export const StringFormatSettings: FC<StringFormatSettingsProps> = ({
  subType,
  onChangeFormatSubType,
  attributeSelectorType,
  childrenBefore,
  children,
}) => {
  const { t } = useTranslation("dialogs");

  const formatTypesOptions = useMemo<ResourceTypeItem[]>(
    () => [
      {
        text: t("text", { ns: "common" }),
        icon: "text_format",
        value: StringSubType.None,
      },
      {
        text: t("media", { ns: "common" }),
        icon: "image",
        value: StringSubType.Image,
      },
    ],
    [t],
  );

  const changeStringSubType = useCallback(
    ({ value }: ResourceTypeItem) => {
      onChangeFormatSubType(value as StringSubType);
    },
    [onChangeFormatSubType],
  );

  return (
    <StringFormSettingsContainer height={"unset"}>
      <StringResourceType
        typeWidth={"8.625rem"}
        resourceTypes={formatTypesOptions}
        selectedType={subType}
        onSelect={changeStringSubType}
      />
      <StringFormSettingsContentContainer>
        {childrenBefore}
        {subType === StringSubType.None && (
          <Hint>
            <Label>{t("dialogComponents.header")}:</Label>
            {attributeSelectorType === AttributeSelectorType.SelectFromHandBook && (
              <div>{t("recordFromDictionary", { ns: "common" })}</div>
            )}
            {attributeSelectorType === AttributeSelectorType.ViewHandBook && (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <Link>{t("dialogComponents.textAttribute")}</Link>
            )}
            {(!attributeSelectorType || attributeSelectorType === AttributeSelectorType.None) && (
              <div>{t("dialogComponents.textAttribute")}</div>
            )}
          </Hint>
        )}
        {subType === StringSubType.Image && (
          <ImageFormatPreviewContainer>
            <ImagePreview>
              <ImagePreviewIcon kind={"image"} />
            </ImagePreview>
            <ImagePreview>
              <ImagePreviewIcon kind={"image"} />
            </ImagePreview>
            <ImagePreview>
              <ImagePreviewIcon kind={"image"} />
            </ImagePreview>
          </ImageFormatPreviewContainer>
        )}
        {children}
      </StringFormSettingsContentContainer>
    </StringFormSettingsContainer>
  );
};
